import React from 'react'
import Grid from '@material-ui/core/Grid'
import { useDispatch } from 'react-redux'
import { useStyles } from './style'
import { useNavigate } from 'react-router-dom'
import { registerSlice } from '../../reducers'

const RegisterHeader = () => {
  const classes = useStyles()
  const navigate = useNavigate()
  const dispatcher = useDispatch()

  const homeClick = () => {
    dispatcher(registerSlice.actions.setRegisterData({ isRegistered: false }))
    navigate('/')
  }

  return (
    <Grid container direction='row'>
      <Grid item xs>
        <div className={classes.box}>
          <img
            src='img/mindtools-lpb-logo_65.png'
            alt='MindTools for Business Home'
            onClick={homeClick}
            className={classes.image}
          />
        </div>
      </Grid>
    </Grid>
  )
}

export default RegisterHeader
